import type { SelectorSection } from '@astryxdesign/core/Selector'
import type { ModelOption } from '../services/models'

/** One Selector section per provider, in the order the server listed them. */
export function modelSelectorOptions(models: ModelOption[]): SelectorSection[] {
  const sections: SelectorSection[] = []
  for (const model of models) {
    let section = sections.find((s) => s.title === model.providerLabel)
    if (!section) {
      section = { type: 'section', title: model.providerLabel, options: [] }
      sections.push(section)
    }
    section.options.push({ value: model.id, label: model.label })
  }
  return sections
}
